import React from 'react';
import { useSelector } from 'react-redux';

import { GROUP_ORDER_JOIN_LEAVE_CONFIRMATION_MODAL } from 'constants/cart';
import { ONLINE_ORDERING_BASE_PATH } from 'bento-ordering/base/constants/basePaths';
import { getBaseMenuPathForLocation } from 'bento-ordering/menus/selectors';
import {
  selectCartGroupOrderIsMaxGuestsReached,
  selectCartGroupOrderCartClosed
} from 'bento-ordering/cart/selectors/index';
import ConfirmContainer from 'bento-ordering/base/containers/ConfirmContainer';
import GroupOrderJoin from 'bento-ordering/group_ordering/components/GroupOrderJoin';
import GroupOrderJoinLeaveConfirmation from 'bento-ordering/group_ordering/components/GroupOrderJoinLeaveConfirmation';
import GroupOrderJoinMaxGuestsReached from 'bento-ordering/group_ordering/components/GroupOrderJoinMaxGuestsReached';
import GroupOrderJoinCartClosed from 'bento-ordering/group_ordering/components/GroupOrderJoinCartClosed';

const GroupOrderJoinManager = () => {
  const baseMenuPath = useSelector(getBaseMenuPathForLocation);
  const isMaxGuestsReached = useSelector(
    selectCartGroupOrderIsMaxGuestsReached
  );
  const isCartClosed = useSelector(selectCartGroupOrderCartClosed);

  const handleConfirm = () => {
    window.location.replace(`${ONLINE_ORDERING_BASE_PATH}${baseMenuPath}`);
  };

  return (
    <ConfirmContainer>
      {(isOpen, modalType, toggleIsOpen) => (
        <>
          {!isOpen &&
            (isMaxGuestsReached ? (
              <GroupOrderJoinMaxGuestsReached handleClick={handleConfirm} />
            ) : isCartClosed ? (
              <GroupOrderJoinCartClosed handleClick={handleConfirm} />
            ) : (
              <GroupOrderJoin
                handleClose={() =>
                  toggleIsOpen(GROUP_ORDER_JOIN_LEAVE_CONFIRMATION_MODAL)
                }
              />
            ))}
          {isOpen &&
            modalType === GROUP_ORDER_JOIN_LEAVE_CONFIRMATION_MODAL && (
              <GroupOrderJoinLeaveConfirmation
                toggleIsOpen={toggleIsOpen}
                handleConfirm={handleConfirm}
              />
            )}
        </>
      )}
    </ConfirmContainer>
  );
};

export default GroupOrderJoinManager;
